<template>
  <v-form v-model="isFormValid" ref="form">
    <div>
      <dashboard-header :text="item ? $t('ui.titleUpdate'): $t('ui.titleCreate')" :on-back="goBack"/>
      <div class="d-flex justify-center align-center">
        <v-card
            elevation="0"
            :loading="loading"
            class="card-border-10 w-75">

            <v-card class="m-4" outlined>
              <div class="d-flex custom-card-head p-4">
                <div class="d-inline text-sm-h5 ">{{ $t('title.information') }}</div>
              </div>
              <v-divider class="ma-0"></v-divider>
              <div class="px-6 pt-6">
                <div class="d-flex">
                  <div class="text-h6 mark-title">*</div>
                    <p class="ms-1 text-sm-h5">{{ $t("title.name") }}</p>
                  </div>

                <v-textarea
                    v-model="name"
                    :placeholder="placeholderName"
                    :rules="ruleTitleName"
                    counter="100"
                    rows="1"
                    auto-grow
                    item-text="name"
                    outlined>
                </v-textarea>
              </div>
            </v-card>

            <div class="m-4">
              <v-btn
                  :disabled="!isFormValid"
                  class="no-uppercase btn-custom-primary"
                  elevation="0"
                  @click="onSave">
                {{ $t("ui.save") }}
              </v-btn>
            </div>
        </v-card>
      </div>

    </div>

  </v-form>
</template>

<script>
import {API2} from "../../api";
import i18n from "../../lang/i18n";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";

export default {
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    },
  },
  computed: {
    labelName: () => i18n.t("title.name"),
    placeholderName: () => i18n.t("title.enterName"),
    ruleTitleName() {
      return [
        this.name.length > 0
        && this.name.length <= 100
        && this.name.trim().length > 0
        || this.$t("ui.MSG0045")
      ]
    },
  },
  data() {
    return {
      name: "",
      isFormValid: false,
    };
  },
  watch: {
    item: {
      handler(newItem) {
        this.onTab(newItem);
      },
      immediate: true
    }
  },
  mounted() {
    if (this.item) {
      this.onTab(this.item);
    }
  },
  methods: {
    async onTab(item) {
      // Safety check for form reference
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
      if (item) {
        await this.getData(item)
      } else {
        this.name = "";
      }
    },
    async getData(item) {
      const detail = await this.get(API2.TITLE, {path: item.data.idDetail})
      if (!detail) {
        this.goBack()
        return
      }
      this.name = detail.name;
    },
    goBack() {
      this.openTab(0)
    },
    async onSave() {
      let data = {
        name: this.name
      }
      if (this.item) {
        data.path = this.item.data.idDetail
      }
      let res = this.item ? await this.put(API2.TITLE, data) : await this.post(API2.TITLE, data)
      if (!res) return
      this.showToast("success", i18n.t("ui.toastSuccess"), '')
      this.goBack()
    }
  }
};
</script>

<style scoped>

.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

</style>
